export default __webpack_public_path__ + "static/media/le_mont7.65072a50.jpg";